/* tslint:disable */
/* eslint-disable */
/**
 * WeWalk API V2.0
 * Backend service for WeWALK Mobile Applications, written in **TypeScript** and runs on **NodeJS**. Using **MongoDB** for database, **mongoose** for ORM, **Redis Cache** for caching auth tokens. In cloud, runs in Azure App Services (wewalk-backend-v2). For cloud database, it uses MongoDB inside Azure Cosmos DB. For passwordless authentication, Firebase Authentication is used, other than that, users can use email-password sign-in as well. Transportation services are fed by [Azure Maps Mobility Services](https://docs.microsoft.com/en-us/rest/api/maps/mobility) [RAW JSON](/api/v2/documentation) - [Swagger Editor](https://editor.swagger.io) <br><br> Production Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI'/> <br><br>Test Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI-staging'/>
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EmptyRequest } from '../models';
import { ErrorModelResponse } from '../models';
import { WNewsArchiveResponse } from '../models';
/**
 * WnewsApi - axios parameter creator
 * @export
 */
export const WnewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the archive of WNews
         * @param {EmptyRequest} body Empty request
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wnewsArchivePost: async (body: EmptyRequest, contentLanguage?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling wnewsArchivePost.');
            }
            const localVarPath = `/wnews/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            if (contentLanguage !== undefined && contentLanguage !== null) {
                localVarHeaderParameter['Content-Language'] = String(contentLanguage);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WnewsApi - functional programming interface
 * @export
 */
export const WnewsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the archive of WNews
         * @param {EmptyRequest} body Empty request
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wnewsArchivePost(body: EmptyRequest, contentLanguage?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WNewsArchiveResponse>> {
            const localVarAxiosArgs = await WnewsApiAxiosParamCreator(configuration).wnewsArchivePost(body, contentLanguage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WnewsApi - factory interface
 * @export
 */
export const WnewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get the archive of WNews
         * @param {EmptyRequest} body Empty request
         * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wnewsArchivePost(body: EmptyRequest, contentLanguage?: string, options?: any): AxiosPromise<WNewsArchiveResponse> {
            return WnewsApiFp(configuration).wnewsArchivePost(body, contentLanguage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WnewsApi - object-oriented interface
 * @export
 * @class WnewsApi
 * @extends {BaseAPI}
 */
export class WnewsApi extends BaseAPI {
    /**
     * 
     * @summary Get the archive of WNews
     * @param {EmptyRequest} body Empty request
     * @param {string} [contentLanguage] Content language, like &#x27;tr&#x27;, or &#x27;en&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WnewsApi
     */
    public wnewsArchivePost(body: EmptyRequest, contentLanguage?: string, options?: any) {
        return WnewsApiFp(this.configuration).wnewsArchivePost(body, contentLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}
